import { t } from "@/lib/i18n/messages";
import { formatDate, formatCurrency } from "@/lib/utils/format";
import { buildCsvString, downloadCsv, todayDateString } from "@/lib/utils/csv";
import type { Transaction } from "@/types/wallet";
import type { Locale } from "@/types/auth";

function buildCsvContent(transactions: Transaction[], locale: Locale): string {
  const headers = [
    t(locale, "date"),
    t(locale, "type"),
    t(locale, "direction"),
    t(locale, "amount"),
    t(locale, "status"),
    t(locale, "settled"),
    t(locale, "fee"),
    t(locale, "commission"),
    t(locale, "initiative"),
    "ID",
  ];

  const rows = transactions.map((tx) => [
    formatDate(tx.created_at, locale),
    tx.transaction_type ?? "",
    tx.direction ?? "",
    formatCurrency(tx.total_amount, locale),
    tx.status ?? "",
    tx.settled ? t(locale, "yes") : t(locale, "no"),
    tx.fee != null ? formatCurrency(tx.fee, locale) : "",
    tx.commission != null ? formatCurrency(tx.commission, locale) : "",
    tx.initiative?.title ?? "",
    tx.id,
  ]);

  return buildCsvString([headers, ...rows]);
}

export function exportTransactionsToCsv(
  transactions: Transaction[],
  locale: Locale,
  filename?: string
): void {
  const content = buildCsvContent(transactions, locale);
  downloadCsv(content, filename ?? `transactions-${todayDateString()}.csv`);
}
